import { rem, token, tone } from '@thiememeulenhoff/lit-sdk';
import { css } from 'lit';

export const sliderStyles = [
  css`
    :host {
      display: flex;
      flex-direction: column;
    }

    .slider {
      accent-color: ${tone('info', 'border')};
      color: ${token('foreground-primary')};
    }

    :where(label) {
      font-size: ${rem(16)};
      font-weight: bold;
    }
  `,
];
